<div class="base-loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>